// extracted by mini-css-extract-plugin
export default {"naValue":"DetailValue_naValue__QHfee","detailValue":"DetailValue_detailValue__Xo+sE"};